import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
import { Action, Challenge, Country, Exact, Frame, Idea, IdeaAuthor, IdeaConclusion, IdeaExpectation, InputMaybe, Scalars, SustainabilityKaizen, Unity } from "../graphql";


export class ItemListProps {
  id: string;
  text: string;
  completed: boolean;
  resp: string;
  term: string;
  finishedIn: string;
  detailsVisible: boolean;
  done: string
};

export class TasksProps {
  id: string;
  task: string;
  responsible: string;
  deadline: string;
  finishedIn: string;
  completed: boolean;
  createdAt: string;
  updatedAt: string;
  delete: string;
  done?: string;
  detailsVisible: boolean;
};

interface User {
  balanceInitial: number;
  deletedAt: string | null;
  email: string;
  id: string;
  name: string;
  photo: string | null;
  points?: number;
  role: string;
}

export interface File {
  id: string;
  fileName: string;
  ideaKaizenId: string;
  requestId: number;
  eTag: string;
  versionId: string;
}

export interface Line {
  id: string;
  name: string;
  frame: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface CommentKaizen {
  comment: string;
  createdAt: string;
  deletedAt: string | null;
  id: string;
  updatedAt: string | null;
  user: User;
}

// ----------
export const IdeaKaizenFragmentDoc = gql`
fragment IdeaKaizen on IdeaKaizen {
  id
  title
  status
  code
  authorName
  re
  line {
    id
    name
  }
  frame {
    id 
    name
    lines {
      id
      name
    }
  }
  committee {
    id
  }
  points
  description
  role
  turn
  managerName
  phone
  phoneExtensionLine
  costCenter
  contactHour
  productiveEquipament
  productiveDescription
  areaResponsible
  areaExtensionLine
  email
  unity {
    id
  }
  authors {
    name
    re
  }
  problem
  solution
  financialGain
  productivityGain
  sustainabilityGain
  initialDate
  conclusionDate
  createdAt
}
`;

export class SearchIdeaInput {
  authorName?: InputMaybe<Array<Scalars["String"]>>;
  committeeId?: InputMaybe<Array<Scalars["String"]>>;
  countryId?: InputMaybe<Scalars["String"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  keyword?: InputMaybe<Scalars["String"]>;
  order?: InputMaybe<Scalars["String"]>;
  page?: InputMaybe<Scalars["Int"]>;
  start?: InputMaybe<Scalars["DateTime"]>;
  status?: InputMaybe<Array<Scalars["String"]>>;
  unityId?: InputMaybe<Scalars["String"]>;
}

export type SearchAllIdeasKaizenQueryVariables = Exact<{
  input: SearchIdeaInput;
}>;

export type SearchAllIdeasKaizenQuery = {
  searchAllIdeaKaizen: {
    currentPage: number;
    nextPage: boolean;
    pageSize: number;
    previouPage: boolean;
    totalCount: number;
    totalPage: number;
    ideas: Array<IdeaKaizen>;
  };
};

export class IdeaKaizen {
  id: Scalars["String"];
  title: Scalars["String"];
  authorName: Scalars["String"];
  code: Scalars["String"];
  re: Scalars["String"];
  status?: Scalars["String"];
  createdAt: Scalars["DateTime"];
  userId: Scalars["String"];
  frame?: Frame;
  lineId?: Scalars["String"];
  area: Scalars["String"];
  areaExtensionLine?: Scalars["String"];
  areaResponsible?: Scalars["String"];
  authors?: InputMaybe<Array<IdeaAuthor>>;
  challenge?: InputMaybe<Challenge>;
  contactHour?: Scalars["String"];
  costCenter?: Scalars["String"];
  country?: Country;
  description?: Scalars["String"];
  problem?: Scalars["String"];
  solution?: Scalars["String"];
  document: Scalars["String"];
  email?: Scalars["String"];
  managerName?: Scalars["String"];
  phone?: Scalars["String"];
  phoneExtensionLine?: Scalars["String"];
  productiveDescription?: Scalars["String"];
  productiveEquipament: Scalars["Boolean"];
  role?: Scalars["String"];
  turn?: Scalars["String"];
  unity?: InputMaybe<Unity>;
  implementationResume?: Scalars["String"];
  expectations?: InputMaybe<Array<IdeaExpectation>>;
  premiationDate: InputMaybe<Scalars['DateTime']>;
  conclusion?: InputMaybe<IdeaConclusion>;
  analysisFinacialreturn?: Scalars["Float"];
  analysisMachineValue?: Scalars["Float"];
  analysisManValue?: Scalars["Float"];
  financeValue?: Scalars["Float"];
  likes?: Scalars["Int"];
  productivityValueHH?: Scalars["Float"];
  productivityValueHM?: Scalars["Float"];
  statusUser?: Scalars["String"];
  sustentabilityPoint?: Scalars["Float"];
  sustainability?: InputMaybe<Array<SustainabilityKaizen>>;
  sons?: InputMaybe<Array<Idea>> 
  action?: InputMaybe<Array<Action>>;
  line?: InputMaybe<Line>;
  initialDate?: Scalars["String"];
  conclusionDate?: Scalars["String"];
  financialGain?: Scalars["Float"];
  productivityGain?: Scalars["Float"];
  sustainabilityGain?: Scalars["Float"];
  committeeId?: Scalars["String"];
}

export class ideaKaizenFrame {
  id: Scalars["String"];
  name: Scalars["String"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  deletedAt: Scalars["DateTime"];
}

export class IdeaPageKaizen {
  currentPage: Scalars["Int"];
  ideas: Array<IdeaKaizen>;
  nextPage: Scalars["Boolean"];
  pageSize: Scalars["Int"];
  previouPage: Scalars["Boolean"];
  totalCount: Scalars["Int"];
  totalPage: Scalars["Int"];
}

export const IdeaKaizenPageFragmentDoc = gql`
  fragment IdeaKaizenPage on IdeaKaizenPage {
    ideas {
      ...IdeaKaizen
    }
    
    currentPage
    nextPage
    pageSize
    previouPage
    totalCount
    totalPage
  }
  ${IdeaKaizenFragmentDoc}
`;


export const SearchAllIdeasKaizenDocument = gql`
  query SearchAllIdeaKaizen($input: SearchIdeaKaizenInput!) {
    searchAllIdeaKaizen(data: $input) {
      ...IdeaKaizenPage
    }
  }
  ${IdeaKaizenPageFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class SearchAllIdeasKaizenGQL extends Apollo.Query<
  SearchAllIdeasKaizenQuery,
  SearchAllIdeasKaizenQueryVariables
> {
  document = SearchAllIdeasKaizenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

// ------------

export type RemoveIdeaKaizenMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RemoveIdeaKaizenMutation = {
  removeIdeaKaizen: { message: string; status: number };
};

export const DefaultMessageFragmentDoc = gql`
  fragment DefaultMessage on DefaultMessage {
    message
    status
  }
`;

export const RemoveIdeaDocument = gql`
  mutation RemoveIdeaKaizen($id: ID!) {
    removeIdeaKaizen(id: $id) {
      ...DefaultMessage
    }
  }
  ${DefaultMessageFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class RemoveIdeaKaizenGQL extends Apollo.Mutation<
  RemoveIdeaKaizenMutation,
  RemoveIdeaKaizenMutationVariables
> {
  document = RemoveIdeaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

// ---------

export type GetIdeaKaizenQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetIdeaKaizenQuery = {
  getIdeaKaizen: {
    id: string;
    title: string;
    status?: string;
    area: string;
    code: string;
    authorName: string;
    userId: string;
    re: string;
    createdAt: Date;
  };
};

export const GetIdeaKaizenDocument = gql`
  query GetIdeaKaizen($id: String!) {
    getIdeaKaizen(id: $id) {
      ...IdeaKaizen
    }
  }
  ${IdeaKaizenFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeaKaizenGQL extends Apollo.Query<
  GetIdeaKaizenQuery,
  GetIdeaKaizenQueryVariables
> {
  document = GetIdeaKaizenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

// --------

export class UpdateIdeaKaizen {
  title?: Scalars["String"];
  authorName?: Scalars["String"];
  code?: Scalars["String"];
  re?: Scalars["String"];
  status?: Scalars["String"];
  line?: Scalars["String"];
  frame?: Scalars["String"];
  createdAt?: Scalars["DateTime"];
  userId?: Scalars["String"];
  lineId?: Scalars["String"];
  area?: Scalars["String"];
  unity?: {
    id: Scalars["String"];
  };
  problem?: Scalars["String"];
  solution?: Scalars["String"];
  financialGain?: Scalars["Float"];
  productivityGain?: Scalars["Float"];
  sustainabilityGain?: Scalars["Float"];

  initialDate?: Scalars["DateTime"];
  conclusionDate?: Scalars["DateTime"];
}

export class UpdateIdeaKaizenInput {
  id: Scalars["String"];
  title?: Scalars["String"];
  image?: Scalars["String"];
  authorName?: Scalars["String"];
  code?: Scalars["String"];
  re?: Scalars["String"];
  status?: Scalars["String"];
  createdAt?: Scalars["DateTime"];
  userId?: Scalars["String"];
  area?: Scalars["String"];
}

export type UpdateIdeaKaizenMutation = {
  updateIdeaKaizen: { id: string; ideaKaizen: UpdateIdeaKaizenInput };
};

export type UpdateIdeaKaizenMutationVariables = Exact<{
  input: UpdateIdeaKaizenInput;
}>;

export const UpdateIdeaKaizenDocument = gql`
  mutation UpdateIdeaKaizen($input: UpdateIdeaKaizenInput!) {
    updateIdeaKaizen(data: $input) {
      ...IdeaKaizen
    }
  }
  ${IdeaKaizenFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class UpdateIdeaKaizenGQL extends Apollo.Mutation<
  UpdateIdeaKaizenMutation,
  UpdateIdeaKaizenMutationVariables
> {
  document = UpdateIdeaKaizenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

// ---------------------

export class AcceptIdeaKaizenCommitteeInput {
  id: Scalars['String'];
};

export class AcceptIdeaKaizenInput {
  committee: AcceptIdeaKaizenCommitteeInput;
  id: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type AcceptIdeaKaizenMutation = { acceptIdea: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } };

export type AcceptIdeaKaizenMutationVariables = Exact<{
  input: AcceptIdeaKaizenInput;
}>;

export const AcceptIdeaKaizenDocument = gql`
    mutation AcceptIdeaKaizen($input: AcceptIdeaKaizenInput!) {
  acceptIdeaKaizen(data: $input) {
    ...IdeaKaizen
  }
}
    ${IdeaKaizenFragmentDoc}`;


@Injectable({
  providedIn: 'root'
})
export class AcceptIdeaKaizenGQL extends Apollo.Mutation<AcceptIdeaKaizenMutation, AcceptIdeaKaizenMutationVariables> {
  document = AcceptIdeaKaizenDocument;
  
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

// -----------------------------

export class CreateIdeaAuthorInput {
  area?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  re: Scalars['String'];
};

export class CreateIdeaChallengeInput {
  id: Scalars['String'];
  language: Scalars['String'];
};

export class CreateIdeaCountryInput {
  id: Scalars['String'];
};

export class CreateIdeaExpectationInput {
  /** pt-BR|es-ES */
  challengeLanguage?: InputMaybe<Scalars['String']>;
  /** Enum finance|productive|sustainability */
  expectation: Scalars['String'];
  expectationDescription: Scalars['String'];
};

export class CreateIdeaUnityInput {
  id: Scalars['String'];
};
export class CreateIdeaKaizenInput {
  areaExtensionLine?: Scalars['String'];
  areaResponsible?: Scalars['String'];
  authorName?: Scalars['String'];
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge?: CreateIdeaChallengeInput;
  contactHour?: Scalars['String'];
  costCenter?: Scalars['String'];
  country?: CreateIdeaCountryInput;
  description?: Scalars['String'] | null;
  bucketRequestId?: Scalars['String'];
  points?: Scalars['Int'];
  document?: Scalars['String'];
  email?: Scalars['String'];
  frame: Scalars['String'];
  area: Scalars['String'];
  expectation?: InputMaybe<Array<CreateIdeaExpectationInput>>;
  managerName?: Scalars['String'];
  phone?: Scalars['String'];
  phoneExtensionLine?: Scalars['String'];
  productiveDescription?: InputMaybe<Scalars['String']>;
  productiveEquipament?: Scalars['Boolean'];
  re: Scalars['String'];
  role?: Scalars['String'];
  title: Scalars['String'];
  turn?: Scalars['String'];
  unity?: CreateIdeaUnityInput;
  userId: Scalars['String'];
  problem?: Scalars['String'];
  solution?: Scalars['String'];
};

export type CreateIdeaKaizenMutationVariables = Exact<{
  data: CreateIdeaKaizenInput;
}>;


export type CreateIdeaKaizenMutation = { createIdeaKaizen: { 
  id: string, 
  title: string, 
  description?: string, 
  authorName: string, 
  role?: string, 
  re: string, 
  turn?: string, 
  managerName?: string, 
  phone?: string, 
  costCenter?: string, 
  contactHour?: string, 
  productiveEquipament?: boolean, 
  areaResponsible?: string, 
  areaExtensionLine?: string,
  email?: string, 
  createdAt: Date, 
  updatedAt?: Date, 
  country?: { id: string, name: string }, 
  authors?: Array<{ id: string, name: string, re: string }>, 
  unity?: { id: string, name: string }, 
  challenge?: { id: string, name: string }
 } 
};

export const CreateKaizenIdeaDocument = gql`
mutation IdeaKaizen($data: CreateIdeaKaizenInput!) {
createIdeaKaizen(data: $data) {
id
title
authorName
re
createdAt
}
}
`;

@Injectable({
  providedIn: 'root'
})
export class CreateKaizenIdeaGQL extends Apollo.Mutation<CreateIdeaKaizenMutation, CreateIdeaKaizenMutationVariables> {
  document = CreateKaizenIdeaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}


// --------------------------

export type GetAuthorsKaizenQuery = { getAuthorsKaizen: Array<{ authorName: string }> };

export type GetAuthorsKaizenQueryVariables = Exact<{ [key: string]: never; }>;

export const GetAuthorsKaizenDocument = gql`
    query GetAuthors {
    getAuthorsKaizen {
      authorName
  }
}
    `;

@Injectable({
  providedIn: 'root'
})
export class GetAuthorsKaizenGQL extends Apollo.Query<GetAuthorsKaizenQuery, GetAuthorsKaizenQueryVariables> {
  document = GetAuthorsKaizenDocument;
  
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}